import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const formatTime = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return `${hours.toString().padStart(2, '0')} : ${minutes.toString().padStart(2, '0')} : ${seconds.toString().padStart(2, '0')}`;
};

const LoginHistory = ({ userId }) => {
  const [totalSeconds, setTotalSeconds] = useState(0);

  // Fetch from API every 1 minute
  const fetchLogs = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/api/auth/login-logs/summary?user_id=${userId}`,
      );
      const result = res.data[0];

      if (result) {
        const seconds = parseInt(result.total_active_seconds || 0);
        setTotalSeconds(seconds);
      } else {
        setTotalSeconds(0);
      }
    } catch (error) {
      console.error('Failed to fetch login logs', error);
    }
  };

  useEffect(() => {
    fetchLogs(); // Initial load

    const fetchInterval = setInterval(fetchLogs, 60000); // API hit every 60 sec
    const liveTimer = setInterval(() => {
      setTotalSeconds((prev) => prev + 1); // increment every second
    }, 1000);

    return () => {
      clearInterval(fetchInterval);
      clearInterval(liveTimer);
    };
  }, [userId]);

  return (
    <div>
      <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
        <li>{formatTime(totalSeconds)}</li>
      </ul>
    </div>
  );
};

export default LoginHistory;
